import React, { useCallback, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Input, Drawer } from 'antd'
import { userActions } from '../../Redux/_actions'
import { handConstants } from '../../Redux/_reducers'
import styles from './InstaController.module.scss'
import InstaHandResult from '../../Hands/InstaHandResult/InstaHandResult'
import InstaControllerTitle from './InstaControllerTitle'
import InstaControllerFooter from './InstaControllerFooter'
import { selectHand } from '../../Redux/selectors/selectors'
import { useComponentLocale } from '../../hooks/useComponentLocale'

const { TextArea } = Input

function InstaController() {
	const [instaValue, setInstaValue] = useState('')
	const { rawHandRequest, rawHandResponse, rawHandLimitRequest, rawHandLimitResponse, rawHandVisible } =
		useSelector(selectHand)

	const { filters } = useSelector((state) => state.handsSlice)

	const localStorageFilters = JSON.parse(localStorage.getItem('filter'))

	const filtersData = localStorageFilters ? localStorageFilters : filters

	const textInput = useRef()
	const dispatch = useDispatch()

	const getLocale = useComponentLocale()

	const gtoSolutionsLocale = getLocale({ component: 'instahand', section: 'insert_single_text' })

	const displayText = !(rawHandResponse || rawHandRequest)

	const onChange = (event) => {
		setInstaValue(event.target.value)
	}

	const onSendHand = useCallback(() => {
		dispatch(userActions.getHandByRawText(instaValue))
	}, [instaValue])

	const onCloseDrawer = useCallback(() => {
		dispatch({ type: handConstants.HAND_RAW_HIDE })
	}, [])

	const onResetHand = useCallback(() => {
		setInstaValue('')
		dispatch({ type: handConstants.HAND_RAW_SUCCESS, rawHandResponse: null })
	}, [])

	return (
		<Drawer
			title={<InstaControllerTitle request={rawHandLimitRequest} response={rawHandLimitResponse} />}
			placement='right'
			closable
			visible={rawHandVisible}
			width={600}
			onClose={onCloseDrawer}
			bodyStyle={{
				background: 'var(--bg_color)',
			}}
			footer={
				<InstaControllerFooter
					rawHandResponse={rawHandResponse}
					rawHandRequest={rawHandRequest}
					onCloseDrawer={onCloseDrawer}
					onSendHand={onSendHand}
					onResetHand={onResetHand}
				/>
			}
		>
			<Row style={{ display: displayText ? 'flex' : 'none' }} className={styles.textRow}>
				<TextArea
					className={styles.textRowTextArea}
					ref={textInput}
					placeholder={gtoSolutionsLocale + '.'}
					value={instaValue}
					onChange={onChange}
				/>
			</Row>

			<Row style={{ height: '100%', display: !displayText ? 'block' : 'none' }}>
				<Col className={styles.instaHandContainer} span={24}>
					<InstaHandResult
						handData={rawHandResponse}
						isLoading={rawHandRequest}
						displayHH={false}
						isTopBar
						filter={filtersData}
					/>
				</Col>
			</Row>
		</Drawer>
	)
}

export default InstaController
